import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {classNames} from '../Support/classNames';
import {PresenterProps, withPresenter} from '../../Support/with_presenter';
import {AdvancedAdvertPresenter} from './AdvancedAdvertPresenter';

export enum AdvancedAdvertType {
    WORKOUT_DETAIL = 'workout_detail',
}

interface OwnProps {
    type?: AdvancedAdvertType;
    className?: string;
}

const AdvancedAdvertComponent: FunctionComponent<OwnProps & PresenterProps<AdvancedAdvertPresenter>> = observer(
    ({type, className, presenter}) => {
        if (presenter.isAdvanced === true) {
            return null;
        }

        if (type === AdvancedAdvertType.WORKOUT_DETAIL) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5>Take your rowing to the next level with advanced insights</h5>
                    </div>
                    <div className="card-body">
                        <p>
                            Spot trends in your training through reports and analyze your performance with powerful
                            tools designed to help you gain insight.
                        </p>
                        <p>
                            <b>Level up your training — become an Advanced Member today!</b>
                        </p>
                        <a href="/account/subscriptions/checkout" className="btn btn-primary">
                            Become an Advanced Member
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5>Take your rowing to the next level with Premium Insights</h5>
                </div>
                <div className="card-body">
                    <p>
                        Unlock powerful tools designed to help you train smarter and perform better. As an Advanced
                        Member, you’ll get access to:
                    </p>
                    <ul>
                        <li>Detailed interval tables with duration, distance, and split times</li>
                        <li>Custom graphs for stroke rate, heart rate, speed, and more</li>
                        <li>Advanced snippet comparisons to analyze sections of your workouts</li>
                    </ul>
                    <p>
                        <b>Level up your training — become an Advanced Member today!</b>
                    </p>
                    <a href="/account/subscriptions/checkout" className="btn btn-primary">
                        Become an Advanced Member
                    </a>
                </div>
            </div>
        );
    },
);

export const AdvancedAdvert = withPresenter<AdvancedAdvertPresenter, OwnProps>(
    (props, component) => new AdvancedAdvertPresenter(component.network.me),
    AdvancedAdvertComponent,
);
